import { render, staticRenderFns } from "./marketBoard.vue?vue&type=template&id=fbf9992a&"
import script from "./marketBoard.vue?vue&type=script&lang=js&"
export * from "./marketBoard.vue?vue&type=script&lang=js&"
import style0 from "./marketBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports